import { extractProcsOps } from "./index.js";
import { collectWindowOps, groupActivity, distinctKey } from "../../src/build/index.js";
import { describeState, reconstructState } from "../../src/build/reconstruct.js";

export const extract = extractProcsOps;
const RANK = { confirmed: 4, failed: 3, unconfirmed: 2, unrecorded: 1 };
export const informedness = (op) => (RANK[op.outcome] || 0) * 10000 + (op.output?.length || 0);
export const collect = (prompts) => collectWindowOps(prompts, { informedness });

// The process NAME. A pid means something for minutes and only on one machine.
export const groupBy = (op) => op.process || distinctKey("unnamed process", op);

// Only a CONFIRMED outcome is an observation of state: an unconfirmed stop tells
// you what was asked for, not what is true.
export const stateOf = (flat) => reconstructState(flat, {
  target: groupBy,
  at: (op) => op.ts,
  read: (op) => (op.outcome !== "confirmed" ? null
    : { running: op.kind === "stop" ? "no" : op.kind === "start" ? "yes" : null }),
  change: (op) => (op.kind === "inspect" ? null : `${op.verb} ${op.process}`),
});

export const build = (flat) => {
  const recon = stateOf(flat);
  const byTarget = new Map(recon.targets.map((t) => [t.target, t]));
  const built = grouped(flat);
  for (const g of built.groups) {
    const e = byTarget.get(g.key);
    if (!e) continue;
    g.state = describeState(e, { fields: ["running"] });
    g.changes = e.changes.map((c) => ({ what: c.what, at: c.at, checked: c.checked, stateDiffered: c.stateDiffered }));
    g.unchecked = e.unchecked;
    if (g.state) g.labels = [g.state.split(" — ")[0].replace("running yes", "was up").replace("running no", "was down"), ...g.labels];
  }
  return built;
};

const grouped = (flat) => groupActivity(flat, {
  key: groupBy,
  label: (op) => op.process,
  seed: () => ({ kinds: {}, outcomes: {}, labels: [], managers: [], unconfirmed: 0 }),
  fold: (g, op) => {
    g.kinds[op.kind] = (g.kinds[op.kind] || 0) + 1;
    g.outcomes[op.outcome] = (g.outcomes[op.outcome] || 0) + 1;
    if (op.outcome === "unconfirmed") g.unconfirmed += 1;
    if (!g.managers.includes(op.manager)) g.managers.push(op.manager);
  },
  finish: (g) => {
    g.labels = [g.unconfirmed ? `${g.unconfirmed} unconfirmed` : null, ...g.managers.slice(0, 2)].filter(Boolean);
  },
});

export const anchor = () => "process";
export const ignore = ["output", "steps", "checks", "pid"];
